<!-- 1		PUBLIC
100		CUSTOMER
200	Basic employee access	EMPLOYEE
300		RESERVATION_USER
350		RESERVATION_ADMIN
400		RATE_QUOTE_USER
450		RATE_QUOTE_ADMIN
500		TASK_USER
525		TASK_EDITOR
550		TASK_ADMIN
600		MESSAGE_USER
625		MESSAGE_EDITOR
650		MESSAGE_ADMIN
700		REPORT_USER
750		REPORT_ADMIN
800		STR_USER
850		STR_ADMIN
900		DOCUMENT_USER
950		DOCUMENT_ADMIN
1000		USER_ADMIN
1050		ADMIN
1100		RATE_ADMIN
1150		RATE_USER
1200		HOMEOWNER_PORTAL_USER
1250	Access any Homeowner Portal	HOMEOWNER_PORTAL_ADMIN
1300	Basic user access to Guest Portal to save favorites, get price updates, etc.	GUEST_PORTAL_USER
1310	Registerd user access to Guest Portal with password and guestMasterProfile	GUEST_PORTAL_USER_REGISTERED
1350	Access any Guest Portal	GUEST_PORTAL_ADMIN
1400		OWNER_PROFILE_USER
1450		OWNER_PROFILE_ADMIN
1500		REVIEW_ADMIN
1550		REVIEW_USER
1600		SOFTWARE_DEV_ADMIN
1700		HR_USER
1750		HR_ADMIN
1800		BIZ_DEV_USER
1850		BIZ_DEV_ADMIN
1900		REALTOR_PORTAL_USER
1950		REALTOR_PORTAL_ADMIN -->


<div *ngIf="currentUserRoles.length > 0">
	<mat-divider></mat-divider>
	<mat-toolbar class="admin-header">
		<mat-toolbar-row *ngIf="currentUser">

			<!-- Logo -->
			<img class="logo-img" src="assets/img/header-logo.png" routerLink="/home" />

			<!-- ═══════════════════════════════════════════════════════════════
			     DESKTOP NAVIGATION  (hidden on tablet / mobile via CSS)
			     ═══════════════════════════════════════════════════════════════ -->
			<div class="nav-desktop">

				<!-- ── NAV SEARCH ─────────────────────────────────────────── -->
				<p-autoComplete
					[(ngModel)]="navSearch"
					[suggestions]="filteredNavItems"
					(completeMethod)="searchNav($event)"
					(onSelect)="onNavSelect($event)"
					field="label"
					placeholder="Search routes..."
					[minLength]="1"
					styleClass="nav-search-ac"
					appendTo="body">
					<ng-template let-item pTemplate="item">
						<div style="display:flex; justify-content:space-between; align-items:center;">
							<div class="nav-search-item">
								<span class="nav-search-label">{{item.label}}</span>
								<small class="nav-search-route">{{item.route}}</small>
							</div>
							<span *ngIf="item.category" style="font-size:10px; background:#e8f4f8; color:#1a4a5a; padding:2px 6px; border-radius:3px; margin-left:8px;">{{item.category}}</span>
						</div>
					</ng-template>
				</p-autoComplete>

				<!-- ── ROCKET ──────────────────────────────────────── -->
				<div>
					<button mat-button [matMenuTriggerFor]="fieldOps"><img src="assets/rocket-logo.svg" height="22" alt="" style="vertical-align:middle; margin-right:6px; margin-top:-2px;">Rocket</button>
					<mat-menu #fieldOps="matMenu">
						<button mat-menu-item routerLink="/field-ops/dispatch">Dispatch Board</button>
						<button mat-menu-item routerLink="/vendors">Vendors</button>
						<button mat-menu-item routerLink="/task-templates">Task Templates</button>
						<button mat-menu-item routerLink="/service-detail-rollup">Service Rollup</button>
						<mat-divider></mat-divider>
						<button mat-menu-item routerLink="/field-ops/my-tasks">&#128247; Rocket Tasks</button>
					</mat-menu>
				</div>

				<!-- ── 1. OPS ─────────────────────────────────────────────── -->
				<div>
					<button mat-button [matMenuTriggerFor]="ops">Ops</button>
					<mat-menu #ops="matMenu">
						<button mat-menu-item routerLink="/ai-agents">AI Agents</button>
						<button mat-menu-item routerLink="/ops-dashboard">Ops Dashboard</button>
						<button mat-menu-item routerLink="/access-codes">Access Codes</button>
						<button mat-menu-item routerLink="/property-features">Property Features</button>
						<button mat-menu-item routerLink="/composite-listings">Composite Listings</button>
						<button mat-menu-item routerLink="/compendiums">Compendiums</button>
						<button mat-menu-item routerLink="/ru-reservations">RU Reservations</button>
						<button mat-menu-item routerLink="/arrival-departure-report">Arrival Departure Report</button>
						<button mat-menu-item routerLink="/jobs">Jobs</button>
						<button mat-menu-item [matMenuTriggerFor]="QualityTestMenu">Quality Test</button>
						<mat-menu #QualityTestMenu="matMenu">
							<button mat-menu-item routerLink="/quality-test-dashboard">Dashboard</button>
							<button mat-menu-item routerLink="/quality-test">Results</button>
							<button mat-menu-item routerLink="/quality-test-definitions">Rule Definitions</button>
							<button mat-menu-item routerLink="/quality-test-field-registry">Field Registry</button>
						</mat-menu>
						<button mat-menu-item routerLink="/data-report">Data Report (legacy)</button>
						<button mat-menu-item routerLink="/travel-agent-profile-list">Travel Agent Profile</button>
						<button mat-menu-item [matMenuTriggerFor]="comms">Communications</button>
						<button mat-menu-item [matMenuTriggerFor]="content">Content</button>
						<button mat-menu-item [matMenuTriggerFor]="actions">Worklist</button>
						<button mat-menu-item [matMenuTriggerFor]="maintenance">Maintenance</button>
						<button mat-menu-item [matMenuTriggerFor]="tools">Tools</button>
						<button mat-menu-item routerLink="/activities-manager">Activities Manager</button>
						<button mat-menu-item routerLink="/code-projects">Code Projects</button>
						<button mat-menu-item routerLink="/code-tasks">Code Tasks</button>
						<button mat-menu-item routerLink="/marketing-dashboard">Marketing Dashboard</button>
					</mat-menu>

					<mat-menu #comms="matMenu">
						<button mat-menu-item [routerLink]="['/unified-inbox', 7]">Unified Inbox</button>
						<button mat-menu-item routerLink="/msg-list">Messages</button>
						<button mat-menu-item routerLink="/msg-campaign-list">Campaigns</button>
						<button mat-menu-item routerLink="/msg-recipient-list">Recipients</button>
						<button mat-menu-item routerLink="/msg-template-list">Templates</button>
						<button mat-menu-item routerLink="/tracked-links">Link Tracker</button>
						<button mat-menu-item routerLink="/inbox-list">Inboxes</button>
						<button mat-menu-item routerLink="/imap-configuration-list">IMAP Configuration</button>
						<button mat-menu-item routerLink="/contact-list">Contacts</button>
						<button mat-menu-item routerLink="/mktg-letter-list">Marketing Letter</button>
						<button mat-menu-item routerLink="/msg-unsubscribe-list">Message Unsubscribe</button>
					</mat-menu>

					<mat-menu #content="matMenu">
						<button mat-menu-item routerLink="/content-ops">Content Ops</button>
						<button mat-menu-item routerLink="/content-list">Content CMS</button>
						<button mat-menu-item routerLink="/landing-page-cms">Landing Page CMS</button>
						<button mat-menu-item routerLink="/article-list">Articles</button>
						<!-- LEGACY: superseded by ACMS content module (Content CMS above) -->
						<!-- <button mat-menu-item routerLink="/blog-list">Blogs</button> -->
						<button mat-menu-item routerLink="/compendiums">Compendiums</button>
						<!-- LEGACY: superseded by ACMS content module -->
						<!-- <button mat-menu-item routerLink="/faq-category-list">FAQ Categories</button> -->
						<!-- <button mat-menu-item routerLink="/faq-section-list">FAQ Sections</button> -->
						<!-- <button mat-menu-item routerLink="/faq-list">FAQ</button> -->
						<button mat-menu-item routerLink="/help-list">Help Pages</button>
						<button mat-menu-item routerLink="/employee-ptos">Employee PTOs</button>
					</mat-menu>

					<mat-menu #actions="matMenu">
						<button mat-menu-item routerLink="/task-list">Worklist</button>
					</mat-menu>

					<mat-menu #maintenance="matMenu">
						<button mat-menu-item routerLink="/maintenance-list">Maintenance List</button>
						<button mat-menu-item routerLink="/maintenance-add">Create Work Order</button>
					</mat-menu>

					<mat-menu #tools="matMenu">
						<button mat-menu-item routerLink="/task-phone-add">Send Message</button>
					</mat-menu>
				</div>

				<!-- ── 2. PROPERTIES ─────────────────────────────────────── -->
				<div>
					<button mat-button [matMenuTriggerFor]="properties">Properties</button>
					<mat-menu #properties="matMenu">
						<button mat-menu-item routerLink="/property-list">Properties</button>
						<button mat-menu-item routerLink="/development-list">Developments</button>
						<button mat-menu-item routerLink="/pictures">Pictures</button>
						<button mat-menu-item routerLink="/property-condition-list">Property Condition</button>
						<button mat-menu-item routerLink="/property-summary-list">Marketing Headlines</button>
						<button mat-menu-item routerLink="/feature-pivot-summary">Feature Matrix</button>
						<button mat-menu-item routerLink="/property-feature-templates">Property Feature Templates</button>
						<button mat-menu-item [matMenuTriggerFor]="TaxFees">Tax &amp; Fees</button>
					</mat-menu>

					<mat-menu #TaxFees="matMenu">
						<button mat-menu-item routerLink="/order-products">Order Products</button>
						<button mat-menu-item routerLink="/order-product-short-term-rental-join">Order Product STR Join</button>
						<button mat-menu-item routerLink="/order-product-tax-join">Order Product Taxes Join</button>
						<button mat-menu-item routerLink="/order-taxes">Order Taxes</button>
						<button mat-menu-item routerLink="/order-tax-short-term-rental-join">Order Tax STR Join</button>
					</mat-menu>
				</div>

				<!-- ── 3. GUESTS ─────────────────────────────────────────── -->
				<div>
					<button mat-button [matMenuTriggerFor]="guests">Guests</button>
					<mat-menu #guests="matMenu">
						<button mat-menu-item [routerLink]="['/unified-inbox', 7]">Unified Inbox</button>
						<button mat-menu-item routerLink="/tapechart">Tape Chart</button>
						<button mat-menu-item routerLink="/best-fit-list">Best Fit Finder</button>
						<button mat-menu-item routerLink="/guest-profile-list">Guest Profile</button>
						<button mat-menu-item routerLink="/quote-list">Quotes</button>
						<button mat-menu-item routerLink="/reservations">Reservations</button>
						<button mat-menu-item routerLink="/reservation-in-out-list">Reservation In-Out List</button>
						<button mat-menu-item [routerLink]="['/inbox-list-vertical', 7]">Guest Comm</button>
						<button mat-menu-item routerLink="/guest-master-profile-list">Guest Master Profile</button>
						<button mat-menu-item routerLink="/maintenance-event">Maintenance Event</button>
						<button mat-menu-item routerLink="/order-list">Orders</button>
						<button mat-menu-item routerLink="/guest-refunds">Refunds</button>
						<button mat-menu-item routerLink="/cancellation-policy-view">Cancellation Policy</button>
						<button mat-menu-item routerLink="/review-list">Reviews</button>
						<button mat-menu-item routerLink="/guest-exit-survey">Survey</button>
						<button mat-menu-item routerLink="/guest-arrival-list">Guest Arrival</button>
						<button mat-menu-item routerLink="/guest-requests">Guest Requests</button>
						<button mat-menu-item routerLink="/arrivals-board">Arrivals Board</button>
						<button mat-menu-item routerLink="/arrivals-agent">Arrivals Dashboard</button>
						<button mat-menu-item routerLink="/vehicle-booking">Vehicle Booking</button>
						<button mat-menu-item routerLink="/reservation-ledger-summary">Reservation Ledger Summary</button>
						<button mat-menu-item routerLink="/reservation-balance-due">Reservation Balance Due</button>
						<button mat-menu-item routerLink="/housekeeping-reports">Housekeeping Reports</button>
						<button mat-menu-item routerLink="/guest-moves">Guest Move</button>
						<button mat-menu-item routerLink="/lost-and-found">Lost &amp; Found</button>
						<button mat-menu-item routerLink="/guest-campaign">Guest Campaign</button>
						<button mat-menu-item routerLink="/travel-insurance-report">Travel Insurance</button>
						<button mat-menu-item [matMenuTriggerFor]="QualityCheck">Quality Check</button>
					</mat-menu>

					<mat-menu #QualityCheck="matMenu">
						<button mat-menu-item routerLink="/check-double-booking">Check Double Booking</button>
						<button mat-menu-item routerLink="/compare-wiki-reservation">Compare Wiki Reservation</button>
						<button mat-menu-item routerLink="/ru-availability-validate">RU Availability Check</button>
					</mat-menu>
				</div>

				<!-- ── 4. BIZDEV (role: 1800) ─────────────────────────────── -->
				<div *ngIf="currentUserRoles.includes(1800)">
					<button mat-button [matMenuTriggerFor]="bizdev">BizDev</button>
					<mat-menu #bizdev="matMenu">
						<button mat-menu-item routerLink="/bizdev-home">Bizdev Home</button>
						<button mat-menu-item routerLink="/bizdev/pipeline">Sales Pipeline</button>
						<button mat-menu-item routerLink="/bizdev-dashboard">Biz Dev Dashboard</button>
						<button mat-menu-item routerLink="/proforma-list">Proformas</button>
						<button mat-menu-item [routerLink]="['/inbox-list-vertical', 9]">BizDev Comm</button>
						<button mat-menu-item routerLink="/real-estate-list">Real Estate</button>
						<button mat-menu-item routerLink="/property-lead-profile-list">Property Leads</button>
						<button mat-menu-item routerLink="/owner-lead-profile-list">Homeowner Leads</button>
						<button mat-menu-item routerLink="/realtor-profile-list">Realtors</button>
						<button mat-menu-item routerLink="/owner-management-cms">Prop Mgmt Landing Pages</button>
						<button mat-menu-item routerLink="/employee-acq-payment">Closed Deals</button>
					</mat-menu>
				</div>

				<!-- ── 5. OWNERS (role: 1400) ─────────────────────────────── -->
				<div *ngIf="currentUserRoles.includes(1400)">
					<button mat-button [matMenuTriggerFor]="owners">Owners</button>
					<mat-menu #owners="matMenu">
						<button mat-menu-item [routerLink]="['/inbox-list-vertical', 8]">Owner Comm</button>
						<button mat-menu-item routerLink="/owner-profile-list">Owner Profile</button>
						<button mat-menu-item routerLink="/inbox-list-vertical/500/10">Owner Profile Comm</button>
						<button mat-menu-item routerLink="/property-profile">Property Profile</button>
						<button mat-menu-item routerLink="/owner-review-list">Owner Reviews</button>
						<button mat-menu-item routerLink="/offboardings">Off Boardings</button>
						<button mat-menu-item routerLink="/onboardings">On Boardings</button>
					</mat-menu>
				</div>

				<!-- ── 6. HR (role: 1700) ───────────────────────────────── -->
				<div *ngIf="currentUserRoles.includes(1700)">
					<button mat-button [matMenuTriggerFor]="hr">HR</button>
					<mat-menu #hr="matMenu">
						<button mat-menu-item routerLink="/employee-profile">Employee Profile</button>
						<button mat-menu-item routerLink="/employee-ptos">Employee PTOs</button>
					</mat-menu>
				</div>

				<!-- ── 7. ADMIN (role: 1050) ─────────────────────────────── -->
				<div *ngIf="currentUserRoles.includes(1050)">
					<button mat-button [matMenuTriggerFor]="admin">Admin</button>
					<mat-menu #admin="matMenu">
						<button mat-menu-item [matMenuTriggerFor]="Accounting">Accounting</button>
						<button mat-menu-item routerLink="/admin-dashboard">Admin Dashboard</button>
						<button *ngIf="currentUserRoles.includes(800) || currentUserRoles.includes(801) || currentUserRoles.includes(803)"
							mat-menu-item [matMenuTriggerFor]="finReports">Reports</button>
						<button mat-menu-item [matMenuTriggerFor]="owner">Owners</button>
						<button mat-menu-item [matMenuTriggerFor]="Development">Development</button>
						<button mat-menu-item [matMenuTriggerFor]="channels">Channels</button>
						<button mat-menu-item [matMenuTriggerFor]="users">Users</button>
						<button mat-menu-item [matMenuTriggerFor]="stats">Stats</button>
						<button mat-menu-item [matMenuTriggerFor]="occmatrix">Occ Matrix</button>
						<button mat-menu-item [matMenuTriggerFor]="dripCampaigns">Drip Campaigns</button>
					</mat-menu>

					<mat-menu #dripCampaigns="matMenu">
						<button mat-menu-item routerLink="/drip-campaign-templates">Campaign Templates</button>
						<button mat-menu-item routerLink="/drip-campaign-instances">Campaign Instances</button>
					</mat-menu>

					<mat-menu #Accounting="matMenu">
						<button mat-menu-item routerLink="/qb-sync">QB Sync</button>
						<button mat-menu-item routerLink="/expense-list">Breezeway Sync/Expenses</button>
						<button mat-menu-item routerLink="/owner-statements">Owner Statements</button>
						<button mat-menu-item routerLink="/owner-stmt-rez-list">Owner Statement Rez</button>
						<button mat-menu-item routerLink="/owner-stmt-exp-list">Owner Statement Exp</button>
						<button mat-menu-item routerLink="/owner-statements-reconciliation">Owner Statement Reconciliation</button>
						<button mat-menu-item routerLink="/payment-confirm-list">Payment Confirms</button>
					</mat-menu>

					<mat-menu #finReports="matMenu">
						<button mat-menu-item routerLink="/reports-dashboard">Dashboard</button>
						<mat-divider></mat-divider>
						<button mat-menu-item routerLink="/daily-report">Daily</button>
						<button mat-menu-item routerLink="/occupancy-summary-report">Occupancy</button>
						<button mat-menu-item routerLink="/vacancy-report">Vacancy</button>
						<button mat-menu-item routerLink="/res-rev-report">Revenue</button>
						<button mat-menu-item routerLink="/res-sales-report">Sales</button>
						<button mat-menu-item routerLink="/escrows-report">Escrows</button>
						<button mat-menu-item routerLink="/res-sales-dashboard">Res Sales Dashboard</button>
						<button mat-menu-item routerLink="/quote-analytics">Quote Analytics</button>
						<button mat-menu-item routerLink="/future-occupancy-report">Future Occupancy</button>
						<button mat-menu-item routerLink="/res-channel-report">Res By Channels</button>
						<button mat-menu-item routerLink="/res-adr-report">Res ADR</button>
						<button mat-menu-item routerLink="/res-sales-dashboard-by-year">Res Sales By Year</button>
						<button mat-menu-item routerLink="/biz-dev-dashboard">Biz Dev Dashboard</button>
						<button mat-menu-item routerLink="/occupancy-dashboard">Occupancy Dashboard</button>
						<button mat-menu-item routerLink="/future-occupancy-dashboard">Future Occupancy Dashboard</button>
						<button mat-menu-item routerLink="/operations-dashboard">Operations Dashboard</button>
						<button mat-menu-item routerLink="/res-master">Res Master</button>
						<button mat-menu-item routerLink="/res-master-escrow">Res Master Escrow</button>
						<button mat-menu-item routerLink="/reservation-summary-report">Reservation Summary</button>
						<button mat-menu-item routerLink="/payment-summary-report">Payment Summary</button>
						<button mat-menu-item routerLink="/travel-insurance-report">Travel Insurance</button>
						<button mat-menu-item routerLink="/reports/tag-revenue">Tag Revenue</button>
					</mat-menu>

					<mat-menu #owner="matMenu">
						<button mat-menu-item routerLink="/owner-profile-guest-list">Owner Profile Guest</button>
						<button mat-menu-item routerLink="/owner-stmt-list">Owner Statement</button>
						<button mat-menu-item routerLink="/owner-stmt-rez-list">Owner Statement Rez</button>
						<button mat-menu-item routerLink="/owner-stmt-rez-detail-list">Owner Statement Rez Detail</button>
						<button mat-menu-item routerLink="/owner-stmt-exp-list">Owner Statement Exp</button>
						<button mat-menu-item routerLink="/owner-stmt-exp-detail-list">Owner Statement Exp Detail</button>
						<button mat-menu-item routerLink="/service-product-list">Service Product</button>
						<button mat-menu-item routerLink="/statements">Owner Stmt View</button>
						<button mat-menu-item routerLink="/chart-account-list">Chart Account</button>
						<button mat-menu-item routerLink="/reservation-ledgers">Reservation Ledgers</button>
						<button mat-menu-item routerLink="/cost-profile">Cost Profile</button>
					</mat-menu>

					<mat-menu #Development="matMenu">
						<button mat-menu-item routerLink="/housekeeping-reports">Housekeeping Reports</button>
						<button mat-menu-item routerLink="/compare-wiki-reservation">Compare Wiki Reservation</button>
						<button mat-menu-item routerLink="/compare-reservation-ledger">Compare Reservation Ledger</button>
						<button mat-menu-item routerLink="/check-double-booking">Check Double Booking</button>
						<button mat-menu-item routerLink="/guest-refund-reasons">Refund Reasons</button>
						<button mat-menu-item routerLink="/reports">System Reports</button>
						<button mat-menu-item routerLink="/reservation-ledgers">Reservation Ledgers</button>
						<button mat-menu-item routerLink="/guest-moves">Guest Move</button>
						<button mat-menu-item routerLink="/activity-fees">Activity Fee</button>
						<button mat-menu-item routerLink="/activity-schedulers">Activity Scheduler</button>
						<button mat-menu-item routerLink="/persons">Person</button>
						<button mat-menu-item routerLink="/person-address">Person Address</button>
						<button mat-menu-item routerLink="/person-emails">Person Email</button>
						<button mat-menu-item routerLink="/person-phones">Person Phone</button>
						<button mat-menu-item routerLink="/person-socials">Person Social</button>
						<button mat-menu-item routerLink="/lost-and-found">Lost and Found</button>
						<button mat-menu-item routerLink="/file-uploads">File Upload</button>
						<button mat-menu-item routerLink="/tags">Tags</button>
						<button mat-menu-item routerLink="/question-answers">Question Answers</button>
						<button mat-menu-item routerLink="/quartz-jobs">Quartz Jobs</button>
						<button mat-menu-item routerLink="/app-events">App Events</button>
					</mat-menu>

					<mat-menu #channels="matMenu">
						<button mat-menu-item routerLink="/rentals-united">Rentals United</button>
						<button mat-menu-item routerLink="/ru-detailed-location">RU Detailed Location</button>
						<button mat-menu-item routerLink="/ru-properties-status-list">OTA Channels</button>
						<button mat-menu-item routerLink="/channels">Channels</button>
						<button mat-menu-item routerLink="/vrbo">VRBO</button>
						<button mat-menu-item routerLink="/vrbo-promotions-dashboard">VRBO Promotions Dashboard</button>
						<button mat-menu-item routerLink="/yield-max">YieldMax</button>
						<button mat-menu-item routerLink="/google">Google</button>
						<button mat-menu-item routerLink="/features">Features</button>
					</mat-menu>

					<mat-menu #users="matMenu">
						<button mat-menu-item routerLink="/users">Users</button>
						<button mat-menu-item routerLink="/user-role-list">User Roles</button>
						<button mat-menu-item routerLink="/teams">Teams</button>
					</mat-menu>

					<mat-menu #stats="matMenu">
						<button mat-menu-item routerLink="/logmans">Logman (Wiki)</button>
						<button mat-menu-item routerLink="/logmans-yieldmax">Logman (YieldMax)</button>
						<button mat-menu-item routerLink="/vrbo-logman">VRBO Logman</button>
						<button mat-menu-item routerLink="/google-logman">Google Logman</button>
					</mat-menu>

					<mat-menu #occmatrix="matMenu">
						<button mat-menu-item routerLink="/occ-maps">Occ Map</button>
						<button mat-menu-item routerLink="/occ-matrix">Occ Matrix</button>
						<button mat-menu-item routerLink="/occ-profiles">Occ Profile</button>
						<button mat-menu-item routerLink="/occ-deviation">Occ Deviation</button>
						<button mat-menu-item routerLink="/occ-days-to-arrival">Occ Days To Arrival</button>
						<button mat-menu-item routerLink="/occ-days-matrix">Occ Days Matrix</button>
					</mat-menu>
				</div>

				<!-- ─── AI + Trip Planner + User buttons ─────────────────── -->
				<button mat-icon-button (click)="toggleAiWidget()" title="AI Assistant"
					style="color: #7c4dff; margin-left: 8px;">
					<mat-icon style="font-size: 28px; line-height: 28px; width: 28px; height: 28px;">auto_awesome</mat-icon>
				</button>
				<button mat-icon-button (click)="openTripPlanner()" title="Trip Planner (Guest Site)"
					style="color: #00897b;">
					<mat-icon style="font-size: 28px; line-height: 28px; width: 28px; height: 28px;">travel_explore</mat-icon>
				</button>
				<button mat-button [matMenuTriggerFor]="currUser">
					<mat-icon style="color:green; font-size:150%">person</mat-icon>
					<span class="user-btn-text">{{currentUser.firstName}} {{currentUser.lastName}} #{{currentUser.userId}}</span>
				</button>
				<mat-menu #currUser="matMenu">
					<button mat-menu-item routerLink="/">Preferences</button>
					<button mat-menu-item (click)="logout()">Logout</button>
				</mat-menu>

			</div><!-- /.nav-desktop -->

			<!-- ═══════════════════════════════════════════════════════════════
			     MOBILE / TABLET HAMBURGER  (hidden on desktop via CSS)
			     ═══════════════════════════════════════════════════════════════ -->
			<!-- Hamburger: opens custom accordion drawer (not mat-menu cascade) -->
			<button class="mobile-menu-btn" mat-icon-button
				title="Navigation menu" aria-label="Open navigation menu"
				(click)="toggleMobileNav()"
				(touchstart)="$event.stopPropagation()">
				<mat-icon>menu</mat-icon>
			</button>

			<!-- ─── AI + User buttons (mobile) ──────────────────────────── -->
			<div class="nav-mobile-icons">
				<button mat-icon-button (click)="toggleAiWidget()" title="AI Assistant"
					style="color: #7c4dff;">
					<mat-icon style="font-size: 28px; line-height: 28px; width: 28px; height: 28px;">auto_awesome</mat-icon>
				</button>
				<button mat-icon-button (click)="openTripPlanner()" title="Trip Planner (Guest Site)" style="color: #00897b; margin-right: 4px;">
					<mat-icon style="font-size: 28px; line-height: 28px; width: 28px; height: 28px;">travel_explore</mat-icon>
				</button>
				<button mat-button [matMenuTriggerFor]="currUserMobile">
					<mat-icon style="color:green; font-size:150%">person</mat-icon>
					<span class="user-btn-text">{{currentUser.firstName}} {{currentUser.lastName}}</span>
				</button>
				<mat-menu #currUserMobile="matMenu">
					<button mat-menu-item routerLink="/">Preferences</button>
					<button mat-menu-item (click)="logout()">Logout</button>
				</mat-menu>
			</div>

		</mat-toolbar-row>
	</mat-toolbar>
	<mat-divider></mat-divider>

	<!-- ═══════════════════════════════════════════════════════════════════
	     MOBILE / TABLET NAVIGATION DRAWER  (≤ 991 px)
	     A slide-in accordion drawer — replaces the broken nested mat-menu
	     cascade that didn't fire correctly on touch devices.
	     ═══════════════════════════════════════════════════════════════════ -->

	<!-- Semi-transparent backdrop — tap to close -->
	<div class="mob-nav-backdrop" [class.open]="mobileNavOpen" (click)="closeMobileNav()"></div>

	<!-- Slide-in drawer -->
	<nav class="mob-nav-drawer" [class.open]="mobileNavOpen">

		<!-- Drawer top bar -->
		<div class="mob-nav-top">
			<span class="mob-nav-title">Menu</span>
			<button class="mob-nav-close-btn" (click)="closeMobileNav()">&#x2715;</button>
		</div>

		<!-- ── OPS ──────────────────────────────────────────────────── -->
		<div class="mob-nav-grp">
			<button class="mob-nav-grp-btn" [class.open]="mobileOpenSections.has('ops')"
				(click)="toggleMobileSection('ops')">
				Ops <span class="mob-chevron"></span>
			</button>
			<div class="mob-nav-grp-body" [class.open]="mobileOpenSections.has('ops')">
				<a routerLink="/ai-agents" (click)="closeMobileNav()">AI Agents</a>
				<a routerLink="/ops-dashboard" (click)="closeMobileNav()">Ops Dashboard</a>
				<a routerLink="/access-codes" (click)="closeMobileNav()">Access Codes</a>
				<a routerLink="/property-features" (click)="closeMobileNav()">Property Features</a>
				<a routerLink="/composite-listings" (click)="closeMobileNav()">Composite Listings</a>
				<a routerLink="/compendiums" (click)="closeMobileNav()">Compendiums</a>
				<a routerLink="/ru-reservations" (click)="closeMobileNav()">RU Reservations</a>
				<a routerLink="/arrival-departure-report" (click)="closeMobileNav()">Arrival Departure Report</a>
				<a routerLink="/jobs" (click)="closeMobileNav()">Jobs</a>
				<a routerLink="/quality-test" (click)="closeMobileNav()">Quality Test</a>
				<a routerLink="/data-report" (click)="closeMobileNav()">Data Report (legacy)</a>
				<a routerLink="/travel-agent-profile-list" (click)="closeMobileNav()">Travel Agent Profile</a>
				<a routerLink="/activities-manager" (click)="closeMobileNav()">Activities Manager</a>
				<a routerLink="/code-projects" (click)="closeMobileNav()">Code Projects</a>
				<a routerLink="/code-tasks" (click)="closeMobileNav()">Code Tasks</a>
				<a routerLink="/marketing-dashboard" (click)="closeMobileNav()">Marketing Dashboard</a>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('comms')"
						(click)="toggleMobileSection('comms')">
						Communications <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('comms')">
						<a routerLink="/msg-list" (click)="closeMobileNav()">Messages</a>
						<a routerLink="/msg-campaign-list" (click)="closeMobileNav()">Campaigns</a>
						<a routerLink="/msg-recipient-list" (click)="closeMobileNav()">Recipients</a>
						<a routerLink="/msg-template-list" (click)="closeMobileNav()">Templates</a>
						<a routerLink="/tracked-links" (click)="closeMobileNav()">Link Tracker</a>
						<a routerLink="/inbox-list" (click)="closeMobileNav()">Inboxes</a>
						<a routerLink="/imap-configuration-list" (click)="closeMobileNav()">IMAP Configuration</a>
						<a routerLink="/contact-list" (click)="closeMobileNav()">Contacts</a>
						<a routerLink="/mktg-letter-list" (click)="closeMobileNav()">Marketing Letter</a>
						<a routerLink="/msg-unsubscribe-list" (click)="closeMobileNav()">Message Unsubscribe</a>
					</div>
				</div>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('content')"
						(click)="toggleMobileSection('content')">
						Content <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('content')">
						<a routerLink="/content-list" (click)="closeMobileNav()">Content CMS</a>
						<a routerLink="/landing-page-cms" (click)="closeMobileNav()">Landing Page CMS</a>
						<a routerLink="/article-list" (click)="closeMobileNav()">Articles</a>
						<a routerLink="/compendiums" (click)="closeMobileNav()">Compendiums</a>
						<a routerLink="/help-list" (click)="closeMobileNav()">Help Pages</a>
						<a routerLink="/employee-ptos" (click)="closeMobileNav()">Employee PTOs</a>
					</div>
				</div>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('worklist')"
						(click)="toggleMobileSection('worklist')">
						Worklist <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('worklist')">
						<a routerLink="/task-list" (click)="closeMobileNav()">Worklist</a>
					</div>
				</div>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('maintenance')"
						(click)="toggleMobileSection('maintenance')">
						Maintenance <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('maintenance')">
						<a routerLink="/maintenance-list" (click)="closeMobileNav()">Maintenance List</a>
						<a routerLink="/maintenance-add" (click)="closeMobileNav()">Create Work Order</a>
					</div>
				</div>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('tools')"
						(click)="toggleMobileSection('tools')">
						Tools <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('tools')">
						<a routerLink="/task-phone-add" (click)="closeMobileNav()">Send Message</a>
					</div>
				</div>
			</div>
		</div>

		<!-- ── PROPERTIES ───────────────────────────────────────────── -->
		<div class="mob-nav-grp">
			<button class="mob-nav-grp-btn" [class.open]="mobileOpenSections.has('properties')"
				(click)="toggleMobileSection('properties')">
				Properties <span class="mob-chevron"></span>
			</button>
			<div class="mob-nav-grp-body" [class.open]="mobileOpenSections.has('properties')">
				<a routerLink="/property-list" (click)="closeMobileNav()">Properties</a>
				<a routerLink="/development-list" (click)="closeMobileNav()">Developments</a>
				<a routerLink="/pictures" (click)="closeMobileNav()">Pictures</a>
				<a routerLink="/property-condition-list" (click)="closeMobileNav()">Property Condition</a>
				<a routerLink="/property-summary-list" (click)="closeMobileNav()">Marketing Headlines</a>
				<a routerLink="/feature-pivot-summary" (click)="closeMobileNav()">Feature Matrix</a>
				<a routerLink="/property-feature-templates" (click)="closeMobileNav()">Property Feature Templates</a>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('taxfees')"
						(click)="toggleMobileSection('taxfees')">
						Tax &amp; Fees <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('taxfees')">
						<a routerLink="/order-products" (click)="closeMobileNav()">Order Products</a>
						<a routerLink="/order-product-short-term-rental-join" (click)="closeMobileNav()">Order Product STR Join</a>
						<a routerLink="/order-product-tax-join" (click)="closeMobileNav()">Order Product Taxes Join</a>
						<a routerLink="/order-taxes" (click)="closeMobileNav()">Order Taxes</a>
						<a routerLink="/order-tax-short-term-rental-join" (click)="closeMobileNav()">Order Tax STR Join</a>
					</div>
				</div>
			</div>
		</div>

		<!-- ── GUESTS ───────────────────────────────────────────────── -->
		<div class="mob-nav-grp">
			<button class="mob-nav-grp-btn" [class.open]="mobileOpenSections.has('guests')"
				(click)="toggleMobileSection('guests')">
				Guests <span class="mob-chevron"></span>
			</button>
			<div class="mob-nav-grp-body" [class.open]="mobileOpenSections.has('guests')">
				<a routerLink="/tapechart" (click)="closeMobileNav()">Tape Chart</a>
				<a routerLink="/guest-profile-list" (click)="closeMobileNav()">Guest Profile</a>
				<a routerLink="/quote-list" (click)="closeMobileNav()">Quotes</a>
				<a routerLink="/reservations" (click)="closeMobileNav()">Reservations</a>
				<a routerLink="/reservation-in-out-list" (click)="closeMobileNav()">Reservation In-Out List</a>
				<a [routerLink]="['/inbox-list-vertical', 7]" (click)="closeMobileNav()">Guest Comm</a>
				<a routerLink="/guest-master-profile-list" (click)="closeMobileNav()">Guest Master Profile</a>
				<a routerLink="/maintenance-event" (click)="closeMobileNav()">Maintenance Event</a>
				<a routerLink="/order-list" (click)="closeMobileNav()">Orders</a>
				<a routerLink="/guest-refunds" (click)="closeMobileNav()">Refunds</a>
				<a routerLink="/review-list" (click)="closeMobileNav()">Reviews</a>
				<a routerLink="/guest-exit-survey" (click)="closeMobileNav()">Survey</a>
				<a routerLink="/guest-arrival-list" (click)="closeMobileNav()">Guest Arrival</a>
				<a routerLink="/guest-requests" (click)="closeMobileNav()">Guest Requests</a>
				<a routerLink="/arrivals-board" (click)="closeMobileNav()">Arrivals Board</a>
				<a routerLink="/arrivals-agent" (click)="closeMobileNav()">Arrivals Dashboard</a>
				<a routerLink="/vehicle-booking" (click)="closeMobileNav()">Vehicle Booking</a>
				<a routerLink="/reservation-ledger-summary" (click)="closeMobileNav()">Reservation Ledger Summary</a>
				<a routerLink="/reservation-balance-due" (click)="closeMobileNav()">Reservation Balance Due</a>
				<a routerLink="/housekeeping-reports" (click)="closeMobileNav()">Housekeeping Reports</a>
				<a routerLink="/guest-moves" (click)="closeMobileNav()">Guest Move</a>
				<a routerLink="/lost-and-found" (click)="closeMobileNav()">Lost &amp; Found</a>
				<a routerLink="/guest-campaign" (click)="closeMobileNav()">Guest Campaign</a>
				<a routerLink="/travel-insurance-report" (click)="closeMobileNav()">Travel Insurance</a>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('qualcheck')"
						(click)="toggleMobileSection('qualcheck')">
						Quality Check <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('qualcheck')">
						<a routerLink="/check-double-booking" (click)="closeMobileNav()">Check Double Booking</a>
						<a routerLink="/compare-wiki-reservation" (click)="closeMobileNav()">Compare Wiki Reservation</a>
						<a routerLink="/ru-availability-validate" (click)="closeMobileNav()">RU Availability Check</a>
					</div>
				</div>
			</div>
		</div>

		<!-- ── BIZDEV (role 1800) ────────────────────────────────────── -->
		<div class="mob-nav-grp" *ngIf="currentUserRoles.includes(1800)">
			<button class="mob-nav-grp-btn" [class.open]="mobileOpenSections.has('bizdev')"
				(click)="toggleMobileSection('bizdev')">
				BizDev <span class="mob-chevron"></span>
			</button>
			<div class="mob-nav-grp-body" [class.open]="mobileOpenSections.has('bizdev')">
				<a routerLink="/bizdev-dashboard" (click)="closeMobileNav()">Biz Dev Dashboard</a>
				<a routerLink="/bizdev/pipeline" (click)="closeMobileNav()">Sales Pipeline</a>
				<a routerLink="/proforma-list" (click)="closeMobileNav()">Proformas</a>
				<a [routerLink]="['/inbox-list-vertical', 9]" (click)="closeMobileNav()">BizDev Comm</a>
				<a routerLink="/real-estate-list" (click)="closeMobileNav()">Real Estate</a>
				<a routerLink="/property-lead-profile-list" (click)="closeMobileNav()">Property Leads</a>
				<a routerLink="/owner-lead-profile-list" (click)="closeMobileNav()">Homeowner Leads</a>
				<a routerLink="/realtor-profile-list" (click)="closeMobileNav()">Realtors</a>
				<a routerLink="/owner-management-cms" (click)="closeMobileNav()">Prop Mgmt Landing Pages</a>
				<a routerLink="/employee-acq-payment" (click)="closeMobileNav()">Closed Deals</a>
			</div>
		</div>

		<!-- ── OWNERS (role 1400) ────────────────────────────────────── -->
		<div class="mob-nav-grp" *ngIf="currentUserRoles.includes(1400)">
			<button class="mob-nav-grp-btn" [class.open]="mobileOpenSections.has('owners')"
				(click)="toggleMobileSection('owners')">
				Owners <span class="mob-chevron"></span>
			</button>
			<div class="mob-nav-grp-body" [class.open]="mobileOpenSections.has('owners')">
				<a [routerLink]="['/inbox-list-vertical', 8]" (click)="closeMobileNav()">Owner Comm</a>
				<a routerLink="/owner-profile-list" (click)="closeMobileNav()">Owner Profile</a>
				<a routerLink="/inbox-list-vertical/500/10" (click)="closeMobileNav()">Owner Profile Comm</a>
				<a routerLink="/property-profile" (click)="closeMobileNav()">Property Profile</a>
				<a routerLink="/owner-review-list" (click)="closeMobileNav()">Owner Reviews</a>
				<a routerLink="/offboardings" (click)="closeMobileNav()">Off Boardings</a>
				<a routerLink="/onboardings" (click)="closeMobileNav()">On Boardings</a>
			</div>
		</div>

		<!-- ── HR (role 1700) ────────────────────────────────────────── -->
		<div class="mob-nav-grp" *ngIf="currentUserRoles.includes(1700)">
			<button class="mob-nav-grp-btn" [class.open]="mobileOpenSections.has('hr')"
				(click)="toggleMobileSection('hr')">
				HR <span class="mob-chevron"></span>
			</button>
			<div class="mob-nav-grp-body" [class.open]="mobileOpenSections.has('hr')">
				<a routerLink="/employee-profile" (click)="closeMobileNav()">Employee Profile</a>
				<a routerLink="/employee-ptos" (click)="closeMobileNav()">Employee PTOs</a>
			</div>
		</div>

		<!-- ── ADMIN (role 1050) ─────────────────────────────────────── -->
		<div class="mob-nav-grp" *ngIf="currentUserRoles.includes(1050)">
			<button class="mob-nav-grp-btn" [class.open]="mobileOpenSections.has('admin')"
				(click)="toggleMobileSection('admin')">
				Admin <span class="mob-chevron"></span>
			</button>
			<div class="mob-nav-grp-body" [class.open]="mobileOpenSections.has('admin')">
				<a routerLink="/admin-dashboard" (click)="closeMobileNav()">Admin Dashboard</a>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('accounting')"
						(click)="toggleMobileSection('accounting')">
						Accounting <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('accounting')">
						<a routerLink="/qb-sync" (click)="closeMobileNav()">QB Sync</a>
						<a routerLink="/expense-list" (click)="closeMobileNav()">Expenses</a>
						<a routerLink="/owner-statements" (click)="closeMobileNav()">Owner Statements</a>
						<a routerLink="/owner-stmt-rez-list" (click)="closeMobileNav()">Owner Statement Rez</a>
						<a routerLink="/owner-stmt-exp-list" (click)="closeMobileNav()">Owner Statement Exp</a>
						<a routerLink="/owner-statements-reconciliation" (click)="closeMobileNav()">Owner Stmt Reconciliation</a>
						<a routerLink="/payment-confirm-list" (click)="closeMobileNav()">Payment Confirms</a>
					</div>
				</div>
				<div class="mob-nav-subgrp"
					*ngIf="currentUserRoles.includes(800)||currentUserRoles.includes(801)||currentUserRoles.includes(803)">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('reports')"
						(click)="toggleMobileSection('reports')">
						Reports <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('reports')">
						<a routerLink="/reports-dashboard" (click)="closeMobileNav()">Dashboard</a>
						<a routerLink="/daily-report" (click)="closeMobileNav()">Daily</a>
						<a routerLink="/occupancy-summary-report" (click)="closeMobileNav()">Occupancy</a>
						<a routerLink="/vacancy-report" (click)="closeMobileNav()">Vacancy</a>
						<a routerLink="/res-rev-report" (click)="closeMobileNav()">Revenue</a>
						<a routerLink="/res-sales-report" (click)="closeMobileNav()">Sales</a>
						<a routerLink="/escrows-report" (click)="closeMobileNav()">Escrows</a>
						<a routerLink="/res-sales-dashboard" (click)="closeMobileNav()">Res Sales Dashboard</a>
						<a routerLink="/quote-analytics" (click)="closeMobileNav()">Quote Analytics</a>
						<a routerLink="/future-occupancy-report" (click)="closeMobileNav()">Future Occupancy</a>
						<a routerLink="/res-channel-report" (click)="closeMobileNav()">Res By Channels</a>
						<a routerLink="/res-adr-report" (click)="closeMobileNav()">Res ADR</a>
						<a routerLink="/res-sales-dashboard-by-year" (click)="closeMobileNav()">Res Sales By Year</a>
						<a routerLink="/biz-dev-dashboard" (click)="closeMobileNav()">Biz Dev Dashboard</a>
						<a routerLink="/occupancy-dashboard" (click)="closeMobileNav()">Occupancy Dashboard</a>
						<a routerLink="/future-occupancy-dashboard" (click)="closeMobileNav()">Future Occupancy Dashboard</a>
						<a routerLink="/operations-dashboard" (click)="closeMobileNav()">Operations Dashboard</a>
						<a routerLink="/res-master" (click)="closeMobileNav()">Res Master</a>
						<a routerLink="/res-master-escrow" (click)="closeMobileNav()">Res Master Escrow</a>
						<a routerLink="/reservation-summary-report" (click)="closeMobileNav()">Reservation Summary</a>
						<a routerLink="/payment-summary-report" (click)="closeMobileNav()">Payment Summary</a>
					</div>
				</div>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('admin-owners')"
						(click)="toggleMobileSection('admin-owners')">
						Owners <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('admin-owners')">
						<a routerLink="/owner-profile-guest-list" (click)="closeMobileNav()">Owner Profile Guest</a>
						<a routerLink="/owner-stmt-list" (click)="closeMobileNav()">Owner Statement</a>
						<a routerLink="/owner-stmt-rez-list" (click)="closeMobileNav()">Owner Statement Rez</a>
						<a routerLink="/owner-stmt-rez-detail-list" (click)="closeMobileNav()">Owner Statement Rez Detail</a>
						<a routerLink="/owner-stmt-exp-list" (click)="closeMobileNav()">Owner Statement Exp</a>
						<a routerLink="/owner-stmt-exp-detail-list" (click)="closeMobileNav()">Owner Statement Exp Detail</a>
						<a routerLink="/service-product-list" (click)="closeMobileNav()">Service Product</a>
						<a routerLink="/statements" (click)="closeMobileNav()">Owner Stmt View</a>
						<a routerLink="/chart-account-list" (click)="closeMobileNav()">Chart Account</a>
						<a routerLink="/reservation-ledgers" (click)="closeMobileNav()">Reservation Ledgers</a>
						<a routerLink="/cost-profile" (click)="closeMobileNav()">Cost Profile</a>
					</div>
				</div>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('dev')"
						(click)="toggleMobileSection('dev')">
						Development <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('dev')">
						<a routerLink="/housekeeping-reports" (click)="closeMobileNav()">Housekeeping Reports</a>
						<a routerLink="/compare-wiki-reservation" (click)="closeMobileNav()">Compare Wiki Reservation</a>
						<a routerLink="/compare-reservation-ledger" (click)="closeMobileNav()">Compare Reservation Ledger</a>
						<a routerLink="/check-double-booking" (click)="closeMobileNav()">Check Double Booking</a>
						<a routerLink="/guest-refund-reasons" (click)="closeMobileNav()">Refund Reasons</a>
						<a routerLink="/reports" (click)="closeMobileNav()">System Reports</a>
						<a routerLink="/reservation-ledgers" (click)="closeMobileNav()">Reservation Ledgers</a>
						<a routerLink="/guest-moves" (click)="closeMobileNav()">Guest Move</a>
						<a routerLink="/activity-fees" (click)="closeMobileNav()">Activity Fee</a>
						<a routerLink="/activity-schedulers" (click)="closeMobileNav()">Activity Scheduler</a>
						<a routerLink="/persons" (click)="closeMobileNav()">Person</a>
						<a routerLink="/person-address" (click)="closeMobileNav()">Person Address</a>
						<a routerLink="/person-emails" (click)="closeMobileNav()">Person Email</a>
						<a routerLink="/person-phones" (click)="closeMobileNav()">Person Phone</a>
						<a routerLink="/person-socials" (click)="closeMobileNav()">Person Social</a>
						<a routerLink="/lost-and-found" (click)="closeMobileNav()">Lost and Found</a>
						<a routerLink="/file-uploads" (click)="closeMobileNav()">File Upload</a>
						<a routerLink="/tags" (click)="closeMobileNav()">Tags</a>
						<a routerLink="/question-answers" (click)="closeMobileNav()">Question Answers</a>
						<a routerLink="/quartz-jobs" (click)="closeMobileNav()">Quartz Jobs</a>
						<a routerLink="/app-events" (click)="closeMobileNav()">App Events</a>
					</div>
				</div>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('channels')"
						(click)="toggleMobileSection('channels')">
						Channels <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('channels')">
						<a routerLink="/rentals-united" (click)="closeMobileNav()">Rentals United</a>
						<a routerLink="/ru-detailed-location" (click)="closeMobileNav()">RU Detailed Location</a>
						<a routerLink="/ru-properties-status-list" (click)="closeMobileNav()">OTA Channels</a>
						<a routerLink="/channels" (click)="closeMobileNav()">Channels</a>
						<a routerLink="/vrbo" (click)="closeMobileNav()">VRBO</a>
						<a routerLink="/vrbo-promotions-dashboard" (click)="closeMobileNav()">VRBO Promotions Dashboard</a>
						<a routerLink="/yield-max" (click)="closeMobileNav()">YieldMax</a>
						<a routerLink="/google" (click)="closeMobileNav()">Google</a>
						<a routerLink="/features" (click)="closeMobileNav()">Features</a>
					</div>
				</div>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('users')"
						(click)="toggleMobileSection('users')">
						Users <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('users')">
						<a routerLink="/users" (click)="closeMobileNav()">Users</a>
						<a routerLink="/user-role-list" (click)="closeMobileNav()">User Roles</a>
						<a routerLink="/teams" (click)="closeMobileNav()">Teams</a>
					</div>
				</div>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('stats')"
						(click)="toggleMobileSection('stats')">
						Stats <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('stats')">
						<a routerLink="/logmans" (click)="closeMobileNav()">Logman (Wiki)</a>
						<a routerLink="/logmans-yieldmax" (click)="closeMobileNav()">Logman (YieldMax)</a>
						<a routerLink="/vrbo-logman" (click)="closeMobileNav()">VRBO Logman</a>
						<a routerLink="/google-logman" (click)="closeMobileNav()">Google Logman</a>
					</div>
				</div>
				<div class="mob-nav-subgrp">
					<button class="mob-nav-subgrp-btn" [class.open]="mobileOpenSections.has('occmatrix')"
						(click)="toggleMobileSection('occmatrix')">
						Occ Matrix <span class="mob-chevron"></span>
					</button>
					<div class="mob-nav-subgrp-body" [class.open]="mobileOpenSections.has('occmatrix')">
						<a routerLink="/occ-maps" (click)="closeMobileNav()">Occ Map</a>
						<a routerLink="/occ-matrix" (click)="closeMobileNav()">Occ Matrix</a>
						<a routerLink="/occ-profiles" (click)="closeMobileNav()">Occ Profile</a>
						<a routerLink="/occ-deviation" (click)="closeMobileNav()">Occ Deviation</a>
						<a routerLink="/occ-days-to-arrival" (click)="closeMobileNav()">Occ Days To Arrival</a>
						<a routerLink="/occ-days-matrix" (click)="closeMobileNav()">Occ Days Matrix</a>
					</div>
				</div>
			</div>
		</div>

		<!-- ── ROCKET ────────────────────────────────────────────── -->
		<div class="mob-nav-grp">
			<button class="mob-nav-grp-btn" [class.open]="mobileOpenSections.has('field-ops')"
				(click)="toggleMobileSection('field-ops')">
				Rocket <span class="mob-chevron"></span>
			</button>
			<div class="mob-nav-grp-body" [class.open]="mobileOpenSections.has('field-ops')">
				<a routerLink="/field-ops/dispatch" (click)="closeMobileNav()">Dispatch Board</a>
				<a routerLink="/field-ops/my-tasks" (click)="closeMobileNav()">Rocket Tasks</a>
				<a routerLink="/vendors" (click)="closeMobileNav()">Vendors</a>
				<a routerLink="/task-templates" (click)="closeMobileNav()">Task Templates</a>
				<a routerLink="/service-detail-rollup" (click)="closeMobileNav()">Service Rollup</a>
			</div>
		</div>

	</nav><!-- /.mob-nav-drawer -->

	<div>
		<app-alert></app-alert>
	</div>
</div>
<div>
	<router-outlet></router-outlet>
</div>

<app-ai-dialog #aiWidget></app-ai-dialog>
